import { AxiosInstance, AxiosResponse } from "axios";
import { ConsultCardsSchemaResponseDTO } from "../entities/ClientApi";

const resourcePrefix = "/ClienteApi";

export class ClientApiResource {
  apiProvider: AxiosInstance;

  constructor(instance: AxiosInstance) {
    this.apiProvider = instance;
  }

  async consultCards(
    cpf: string
  ): Promise<AxiosResponse<ConsultCardsSchemaResponseDTO>> {
    return this.apiProvider.get(
      `${resourcePrefix}/Cliente/ConsultarCartoesCliente?strCpf=${cpf}`
    );
  }
}
